export function Step4({ className }: { className?: string }) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="96" height="96" fill="white" />
      <path
        d="M6 78V80C6 82.21 7.79 84 10 84H86C88.21 84 90 82.21 90 80V78H6Z"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M28.98 27H29.98V25H28.98V27ZM11 78C11 78.5523 11.4477 79 12 79C12.5523 79 13 78.5523 13 78H11ZM28.98 25H16V27H28.98V25ZM16 25C13.2377 25 11 27.2377 11 30H13C13 28.3423 14.3423 27 16 27V25ZM11 30V78H13V30H11Z"
        fill="black"
      />
      <path
        d="M85 78C85 78.5523 85.4477 79 86 79C86.5523 79 87 78.5523 87 78H85ZM67 25H66V27H67V25ZM87 78V30H85V78H87ZM87 30C87 27.2377 84.7623 25 82 25V27C83.6577 27 85 28.3423 85 30H87ZM82 25H67V27H82V25Z"
        fill="black"
      />
      <rect x="45" y="29" width="28" height="26" fill="white" />
      <path
        d="M46.5 55H35V26.2L45.0455 16C51.2761 16 54.7694 16 61 16V32.5"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M35 26H45V15.5"
        stroke="black"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M69 49H67V43C67 41.4087 66.3679 39.8826 65.2426 38.7574C64.1174 37.6321 62.5913 37 61 37C59.4087 37 57.8826 37.6321 56.7574 38.7574C55.6321 39.8826 55 41.4087 55 43V49H53C52.4696 49 51.9609 49.2107 51.5858 49.5858C51.2107 49.9609 51 50.4696 51 51V63C51 63.5304 51.2107 64.0391 51.5858 64.4142C51.9609 64.7893 52.4696 65 53 65H69C69.5304 65 70.0391 64.7893 70.4142 64.4142C70.7893 64.0391 71 63.5304 71 63V51C71 50.4696 70.7893 49.9609 70.4142 49.5858C70.0391 49.2107 69.5304 49 69 49ZM57 43C57 41.9391 57.4214 40.9217 58.1716 40.1716C58.9217 39.4214 59.9391 39 61 39C62.0609 39 63.0783 39.4214 63.8284 40.1716C64.5786 40.9217 65 41.9391 65 43V49H57V43ZM69 63H53V51H69V63Z"
        fill="#656BBB"
      />
    </svg>
  );
}
